import { Model } from './model';
import { Compagnia } from 'src/app/models/compagnia';

export class Collegamento extends Model {
  static apiUrl: string = "collegamenti";

  nome: string;
  ordinale: number;
  url: string;
  compagnia?: Compagnia;

  deserialize(input: any): Collegamento {
    let retV: Collegamento = new Collegamento();
    retV = super.deserialize(input) as Collegamento;
    return retV;
  }

}
